import ActiveIndicator from "@app/components/active-indicator.tsx";
import DeleteButton from "@app/components/delete-button.tsx";
import { ExpenseDetailsModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper";
import { formatDate } from "@app/helpers/time-helper";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onDelete: (id: number) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<ExpenseDetailsModel>();
export const assignmentDefaultExpenseRatesTableDefinition = ({ onEdit, onDelete, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.assignmentExpenseDetailId!)}>
                    <EditIcon />
                </IconButton>
                <DeleteButton onDelete={() => onDelete(item.row.original.assignmentExpenseDetailId!)} />
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.category, { id: "category", header: "Category" }),
    columnHelper.accessor((x) => x.subCategory, { id: "subCategory", header: "Subcategory" }),
    columnHelper.accessor((x) => x.effectiveDate, {
        id: "effectiveDate",
        header: "Effective Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.reimbursable, {
        id: "reimbursable",
        header: "Reimbursable",
        cell: (item) => <ActiveIndicator isActive={item.getValue()} />,
    }),
    columnHelper.group({
        id: "rates",
        header: "Rates",
        columns: [
            columnHelper.accessor((x) => x.costRate, {
                id: "costRate",
                header: "Cost",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.billingRate, {
                id: "billingRate",
                header: "Billing",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.internalRate, {
                id: "internalRate",
                header: "Internal",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
            columnHelper.accessor((x) => x.markupAmount, {
                id: "markupAmount",
                header: "Markup",
                cell: (item) => formatUsd(item.getValue()),
                alignment: "right",
            }),
        ],
    }),
];
